
import { ServiceData } from '@/types/serviceTypes';

export const snowRemovalService: ServiceData = {
  title: 'Snow Removal',
  description: 'Dependable snow removal services keeping your property safe and accessible throughout the winter months.',
  longDescription: [
    'Our professional snow removal services ensure your property remains safe and accessible during the winter months. We understand that snow and ice can create hazardous conditions and disrupt your daily activities, which is why we offer reliable, efficient snow management for both residential and commercial properties.',
    'Our team monitors weather conditions closely and deploys promptly when snow begins to accumulate. Using commercial-grade equipment and effective ice management techniques, we clear driveways, parking lots, walkways, and entrances quickly and thoroughly.',
    'With our seasonal contracts, you can have peace of mind knowing that your snow removal needs are covered all winter long. No more early morning shoveling or worrying about finding a contractor after a heavy snowfall – we\'ve got you covered with consistent, dependable service.'
  ],
  image: '/lovable-uploads/b541e3ea-3486-4882-934b-2e604eba9aae.png',
  features: [
    '24/7 snow monitoring and response',
    'Commercial and residential service',
    'Driveway and parking lot plowing',
    'Walkway and entrance clearing',
    'Ice management and prevention'
  ],
  benefits: [
    'Enhanced safety for family, employees, and visitors',
    'Reduced liability risks',
    'Time savings and convenience',
    'Prompt service during winter weather events',
    'Professional equipment for efficient clearing'
  ],
  process: [
    {
      title: 'Property Assessment',
      description: 'We evaluate your property to identify specific needs and potential challenges.'
    },
    {
      title: 'Service Plan',
      description: 'We create a customized snow removal plan based on your property layout.'
    },
    {
      title: 'Weather Monitoring',
      description: 'Our team tracks weather conditions to ensure timely service.'
    },
    {
      title: 'Prompt Clearing',
      description: 'We remove snow efficiently using the appropriate equipment for your property.'
    }
  ],
  relatedServices: [
    { id: 'lawn-maintenance', title: 'Lawn Maintenance' },
    { id: 'spring-fall-cleanups', title: 'Spring/Fall Clean Ups' },
    { id: 'power-washing', title: 'Power Washing' }
  ]
};
